<template>

  <div class="">
    <b-overlay
      :show="show"
      spinner-variant="primary"
      spinner-large
      rounded="sm"
      style="height:300vh"
      variant="dark"
      id="loader"
    >
    <b-row>
      <b-col cols="12 headerF"><HeaderFixed/></b-col>
      <b-col cols="12 headerM"><HeaderMobile/></b-col>
    </b-row>
      <b-container id="" fluid style="padding-top: 100px;text-align:left">

        <b-row>
          <b-col cols="12">
              <b-breadcrumb style=" background-color: #e9ecef78;">
                  <b-breadcrumb-item href="#home">
                    <router-link to="/">
                        <b-icon icon="house-door" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
                        Home
                    </router-link>
                  </b-breadcrumb-item>

                 <b-breadcrumb-item href="#" active>One-time Settlement Scheme</b-breadcrumb-item>
              </b-breadcrumb>
            </b-col>
        </b-row>


        <b-row>
              <b-col col cols="12" sm="12" md="12" lg="2" style="padding-top: 7px;">
                    <span style="font-weight:600" >Application Number <span class="text-danger">*</span></span>
              </b-col>
              <b-col col cols="8" sm="8" md="8" lg="4">
                  <b-form-input type="text"  id="applNo"  placeholder="Enter your Application Number" trim required />
              </b-col>
              <b-col col cols="4" sm="3" md="3" lg="3">
                    <b-button @click="generatePdf()" block pill variant="primary" size="md" class="go" style="width:100%">
                    Download PDF  </b-icon>
                    </b-button>

              </b-col>
         </b-row>
         <br>
          <b-table style= "text-align:left" responsive striped bordered :items="amicableList" :fields="amicableListFields">
            <template v-slot:cell(applicationNo)="data">
             <span v-html="data.value"></span>
           </template>
            <template v-slot:cell(filePath)="data">
             <span v-html="data.value"></span>
           </template>
          </b-table>

  </b-container>
  <b-modal id="model" centered  scrollable title="ALERT !" :static="true" hide-footer>
    <span class="data" id="modalMsg">  </span>
    <br><br>
      <b-button  style="width:8rem" variant="outline-primary" @click="closeModal('model')">OK</b-button>
  </b-modal>
    </b-overlay>

    <b-modal   no-close-on-esc  no-close-on-backdrop   hide-header id="successModal" centered  scrollable title="Complaint Update" hide-footer>
      <br><br><svg class="modalFont" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="-180 0 500 130">
        <circle class="path circle" fill="none" stroke="#73AF55" stroke-width="6" stroke-miterlimit="10" cx="65.1" cy="65.1" r="62.1"/>
        <polyline class="path check" fill="none" stroke="#73AF55" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" points="100.2,40.2 51.5,88.8 29.8,67.5 "/>
      </svg>
      <p class="success"> Successfully Saved !<br><br>
       <b-button class="btn btn-outline" variant="success" id="" @click="generatePdf()" >Download Acknowledgement</b-button>
      &nbsp &nbsp  <b-button class="btn btn-outline" variant="danger" id="" @click="closeModalSuccess('successModal');" >Close</b-button>
      </p>
    </b-modal>
    <b-modal  no-close-on-esc  no-close-on-backdrop   hide-header id="failureModal" centered  scrollable title="Complaint Update" hide-footer>
    <br><br>  <svg class="modalFont" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="-180 0 500 130">
        <circle class="path circle" fill="none" stroke="#D06079" stroke-width="6" stroke-miterlimit="10" cx="65.1" cy="65.1" r="62.1"/>
        <line class="path line" fill="none" stroke="#D06079" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" x1="34.4" y1="37.9" x2="95.8" y2="92.3"/>
        <line class="path line" fill="none" stroke="#D06079" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" x1="95.8" y1="38" x2="34.4" y2="92.2"/>
      </svg>
      <p class="error">Form Save Failed ! <br><br>
        <b-button class="btn btn-outline" variant="danger" id="" @click="closeModal('failureModal');" >OK</b-button>
         </p>
    </b-modal>
  </div>
</template>

<script>

import HeaderFixed from '@/components/HeaderFixed.vue'
import HeaderMobile from '@/components/HeaderMobile.vue'
import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
Vue.use(Vuex)
const numWords = require('num-words');

import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
 var amicableList;
var thColor = '#0288d1';
var applNo="";
var dateTime;
var dataToSend;
export default {
  name: 'AmicableForm',
  components: {

    'HeaderFixed' : HeaderFixed,
    'HeaderMobile' :HeaderMobile
    //MarqueeText

  },
  computed: {

  },
  data() {
    return {
      show: false,
      amicableList : [],
      amicableListFields :[
          { key: 'slNo', label: 'Sl. No.',thStyle: {width: '5vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
        { key: 'applicationNo', label: 'Application No.',thStyle: {width: '15vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
        { key: 'consNo', label: 'Cons No.',thStyle: {width: '15vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
        { key: 'consName', label: 'Cons Name',thStyle: {width: '15vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
        { key: 'filePath', label: 'Uploaded File',thStyle: {width: '10vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} },
        { key: 'submitDate', label: 'Date',thStyle: {width: '10vw',backgroundColor:thColor,color:'#ffff',border:'solid #ffff 1px'} }
      ]
    }
  },
  methods: {

      numToWord()
      {

        var num=   document.getElementById("paymentAmt").value;
        const amountInWords = numWords(num);
        this.paymentAmtWord=amountInWords;
      },

      closeModal(modal){
        this.$bvModal.hide(modal)
      },
      closeModalSuccess(modal){
        this.$bvModal.hide(modal)
        window.location.reload();
      },



generatePdf() {
  var applNo=   document.getElementById("applNo").value;
  if(applNo == "")
  {
    this.$bvToast.toast('Enter Application Number !', {
      title: `Alert`,
      variant: 'danger',
      solid: true
    })
    document.getElementById("applNo").focus();
    return;
  }
  var link = amicableList.filter(function(obj) { return obj[1] == applNo; });
  console.log(link);



        var docDefinition = {
        pageSize: 'A4',
        pageOrientation: 'portrait',
        content: [
          // { image: '../assets/apdcl_logo.png',  width: 150,  height: 150,},
          { text: 'APPLICATION FORM', style: 'header' },
          // { text: 'AMICABLE ONE-TIME SETTLEMENT SCHEME', style: 'header' },
          { text: 'Special One-time Settlement Scheme, APDCL', style: 'subheader' },
          { text: 'Application No: '+applNo, style: 'applNo' },
          { text: '- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -' },

          { text: 'Applicant details:', style: 'heading' },
          {	text: ['Name of the Consumer: ',	{text: link[0][3], style: 'boldText'}, ],style: 'normalText'},
          { text: ['Consumer Account No: ', {text: link[0][2], style: 'boldText'},], style: 'normalText' },
          { text: ['Correspondence Address: ', {text: link[0][4], style: 'boldText'},], style: 'normalText' },
          { text: ['Designated Email ID: ', {text: link[0][5], style: 'boldText'},], style: 'normalText' },
          { text: ['Contact mobile No.: ', {text: link[0][6], style: 'boldText'},], style: 'normalText' },
          { text: ['WhatsApp contact: ', {text: link[0][7], style: 'boldText'},], style: 'normalText' },
          { text: ['Last bill reference: ', {text: link[0][8], style: 'boldText'},], style: 'normalText' },
          { text: ['Amount outstanding(as on date of application): ', {text: link[0][9], style: 'boldText'},], style: 'normalText' },

          { text: '\n\n Application details:', style: 'heading' },
          { text: ['Settlement Option: ', {text: link[0][20], style: 'boldText'},], style: 'normalText' },
          { text: ['Present status of connection: ', {text: link[0][10], style: 'boldText'},], style: 'normalText' },
          { text: ['Case Reference No: ', {text: link[0][14], style: 'boldText'},], style: 'normalText' },
          { text: ['Case Reference Year: ', {text: link[0][15], style: 'boldText'},], style: 'normalText' },
          { text: ['Present status of litigation: ', {text: link[0][11], style: 'boldText'},], style: 'normalText' },

          { text: '\n\n Detailed Submission:', style: 'heading' },
          { text: ['Reason(s) for preferring litigation against the bill: ', {text: link[0][16], style: 'boldText'},], style: 'normalText' },
          { text: ['Justification in support: ', {text: link[0][17], style: 'boldText'},], style: 'normalText' },
          { text: ['Legal provisions exercised in defence: ', {text: link[0][18], style: 'boldText'},], style: 'normalText' },
          { text: ['Reason(s) for applying under this Amicable One-Time Settlement Scheme: ', {text: link[0][19], style: 'boldText'},], style: 'normalText' },


          { text: '\n\n Declaration:', style: 'heading' },
          { text:
            [
              'hereby undertake that all the details submitted herein are true and correct.',
              ' I also undertake to accept the resolution under this scheme unconditionally and',
              ' withdraw present litigation, if any and not to pursue the matter in any other forum in future.',
              ' I also undertake that in the event of non-compliance to any of the terms of this arrangement under',
              ' this scheme at any point of time, all amount paid under this scheme will be forfeited and',
              ' I will have no claim over it.',

            ],
             style: 'normalText'
           },

           { text: ['Date: ', {text: link[0][24], style: 'boldText'},], style: 'normalText' },
           { text: ['Place: ', {text: link[0][25], style: 'boldText'},], style: 'normalText' },
           { text: ['Applicant Name: ', {text: link[0][23], style: 'boldText'},], style: 'normalText' },



             ],
             styles: {
                  header: {
                  fontSize: 15,
                  bold: true,
                  alignment: 'center',
                  margin: [0, 0, 0, 5]
              },
            subheader: {
                fontSize: 15,
                alignment: 'center',
                bold: true,
                margin: [0, 10, 0, 5]
            },
            applNo: {
                fontSize: 13,
                alignment: 'center',
                color: '#0277bd',
                margin: [0, 10, 0, 5]
            },
            heading: {
                fontSize: 12,
                alignment: 'left',
                bold: true,
                margin: [0, 10, 0, 5]
            },
            normalText: {
                fontSize: 10,
                alignment: 'left',
                margin: [0, 10, 0, 5]
            },
            boldText: {
                fontSize: 11,
                alignment: 'left',
                bold:true,
                margin: [0, 10, 0, 5]
            },
            bottomText: {
                fontSize: 10,
                fontWeight: 600,
                alignment: 'left',
                margin: [0, 10, 0, 5]
            },
            footerText: {
                fontSize: 8,
                alignment: 'center',
                margin: [0, 10, 0, 5]
            },
            tableExample: {
                margin: [0, 5, 5, 0],
                alignment: 'left',
                fontSize: 10,
            }
        },

      };

      pdfMake.createPdf(docDefinition).download(applNo+ ".pdf");
      //setTimeout(function(){ window.location.reload(); }, 2000);

    },
    showStatus()
    {
      var applNo=document.getElementById("applNo").value;
      if(applNo=="")
      {
        this.$bvToast.toast('Enter Application Number !', {
          title: `Alert`,
          variant: 'danger',
          solid: true
        })

        return;
    }

      var parent=this;
      this.show= true;
      axios.get(parent.$urlCommon + "/api/web/getAmicableStatus?applNo="+applNo)
      .then((response) => {
        parent.show= false;
        console.log(response.data);
        document.getElementById("statusDetails").classList.add("showDetails");
        document.getElementById("statusDiv").innerHTML=response.data.amicableStatus;
      })

    }
  },
  mounted()
  {


      var parent=this;
      this.show= true;
      axios.get(this.$urlCommon + "/api/web/getAmicableList")
      .then((response) => {
        parent.show= false;
        console.log(response.data.amicableList);

        amicableList=response.data.amicableList;


        var temp = [];
  var count=1;
        amicableList.forEach(element => {

        var obj = {
          "slNo": count++,
           "applicationNo" : element[1],
           "consNo" : element[2],
           "consName":element[3],
           "filePath":"<a href='"+ element[13] + "' target='_blank'>Download</a>",
           "submitDate":element[24]
           }
         temp.push(obj);
        })
        this.amicableList = temp;


      })
      .catch((e) => {
      console.log("Caught", e);
      this.show= false;
    })

  }

}

</script>

<style scoped="true">
.hideDetails
{
  visibility: hidden;
  opacity: 0;
  transition:visibility 0s, opacity 0.5s linear;
  /* box-shadow: 2px 2px 10px 2px #bdbdbd; */
  padding: 1rem;
  margin-right: 1.5rem;
}
.showDetails
{

  visibility: visible;
 opacity: 1;
}
.sbtBtn
{
  pointer-events: none;
  background-color: grey;
}

.paddingRow{
  padding:0.7rem;
}
.paddingCol{
  padding: none;
}
.label{
font-weight: 600;
}
.data{
  font-weight: 600;
  color: #ff5722         ;
  font-size: 1.5rem;
}
.top{
  text-align: center;
  color:darkblue;
}
.hideDiv
{
   visibility: visible;
  opacity: 0;
  transition:visibility 0s, opacity 0.5s linear;

}
.showDiv
{

  visibility: visible;
 opacity: 1;
}
hr {
   margin-top: 5px;
   margin-bottom: 5px;
  }
.go:focus{
  box-shadow: none;
}

.headerF{
  display: block;
}
.headerM{
  display: none;
}

.paddingLeft30px{
  padding-left: 30px;
}

@media (max-width: 768px) {
    .headerF{
      display: none;
    }
    .headerM{
      display: block;
    }
    .paddingLeft30px{
      padding-left: 0px;
    }
  }
@media only screen and (max-width: 414px) {
  .paddingCol{
    padding: 0.7rem;
  }
  .paddingRow{
    padding: none !important;
  }
  .paddingLeft30px{
    padding-left: 0px;
  }
}
.path {
  stroke-dasharray: 1000;
  stroke-dashoffset: 0;
}
.path.circle {
  -webkit-animation: dash 0.9s ease-in-out;
  animation: dash 0.9s ease-in-out;
}
.path.line {
  stroke-dashoffset: 1000;
  -webkit-animation: dash 0.9s 0.35s ease-in-out forwards;
  animation: dash 0.9s 0.35s ease-in-out forwards;
}
.path.check {
  stroke-dashoffset: -100;
  -webkit-animation: dash-check 0.9s 0.35s ease-in-out forwards;
  animation: dash-check 0.9s 0.35s ease-in-out forwards;
}

p {
  text-align: center;
  margin: 20px 0 60px;
  font-size: 1.25em;
}
p.success {
  color: #73AF55;
}
p.error {
  color: #D06079;
}
@-webkit-keyframes dash {
  0% {
    stroke-dashoffset: 1000;
  }
  100% {
    stroke-dashoffset: 0;
  }
}
@keyframes dash {
  0% {
    stroke-dashoffset: 1000;
  }
  100% {
    stroke-dashoffset: 0;
  }
}
@-webkit-keyframes dash-check {
  0% {
    stroke-dashoffset: -100;
  }
  100% {
    stroke-dashoffset: 900;
  }
}
@keyframes dash-check {
  0% {
    stroke-dashoffset: -100;
  }
  100% {
    stroke-dashoffset: 900;
  }
}

</style>
